export const LOG_OPTIONS = ["id", "createdAt", "user", "event", "data"];
